import { forwardRef } from "react";
import classnames from "clsx";
import { StyledInput } from "./style";
import Feedback from "../feedback";
import { IInputProps } from "../types";

interface IProps extends IInputProps {
    type?: string;
    autoComplete?: string;
    defaultValue?: string;
}

const Input = forwardRef<HTMLInputElement, IProps>(
    (
        {
            className,
            type,
            disabled,
            state,
            feedbackText,
            id,
            name,
            onChange,
            onClick,
            onBlur,
            value,
            readonly,
            showState,
            showErrorOnly,
            defaultValue,
            width,
            height,
            autoComplete,
            customStyle,
            ...restProps
        },
        ref
    ) => {
        return (
            <>
                <StyledInput
                    type={type}
                    disabled={disabled}
                    ref={ref}
                    className={classnames(className, "form-control")}
                    id={id}
                    name={name}
                    onChange={onChange}
                    onClick={onClick}
                    onBlur={onBlur}
                    value={value}
                    readOnly={readonly}
                    defaultValue={defaultValue}
                    $state={state}
                    $showState={showState}
                    $showErrorOnly={showErrorOnly}
                    $width={width}
                    $height={height}
                    $customStyle={customStyle}
                    autoComplete={autoComplete}
                    {...restProps}
                />
                {feedbackText && showState && (
                    <Feedback
                        state={state}
                        showState={showState}
                        showErrorOnly={showErrorOnly}
                    >
                        {feedbackText}
                    </Feedback>
                )}
            </>
        );
    }
);

Input.displayName = "Input";

Input.defaultProps = {
    type: "text",
    showErrorOnly: true,
};

export default Input;
